/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summarycheckins2Inputs */

const en_summarycheckins2 = /** @type {(inputs: Summarycheckins2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-ins`)
};

const de_summarycheckins2 = /** @type {(inputs: Summarycheckins2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-ins`)
};

/**
* | output |
* | --- |
* | "Check-ins" |
*
* @param {Summarycheckins2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summarycheckins2 = /** @type {((inputs?: Summarycheckins2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summarycheckins2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summarycheckins2(inputs)
	return de_summarycheckins2(inputs)
});
export { summarycheckins2 as "summaryCheckIns" }